import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

export class AdminRoute extends Component {
    render() {
        const { isAdmin, component, ...rest } = this.props;

        return (
            <Route 
                {...rest }
                render={ props => isAdmin ? React.createElement(component, props) : <Redirect to="/dashboard"/> }
            />
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        isAdmin: state.user.isAdmin
    });
};

export default connect(mapStateToProps)(AdminRoute);


// WEBPACK FOOTER //
// ./src/scenes/RouteWrapper/AdminRoute/AdminRoute.js